import * as  moment from 'moment';

export default class StringUtils {

    public static getKendoPercentageFormat(): string {
        return '{0:p}';
    }

    public static getDayDateFormat(date: Date, language: any): string {
        moment.locale(language);
        return moment(date).format('dddd DD/MM/YYYY');
    }

    public static getDateFormat(date: Date): string {
        return moment(date).format('DD/MM/YYYY');
    }

    public static getDateTimeFormat(date: Date): string {
        return moment(date).format('HH:mm:ss DD/MM/YYYY');
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/string-utils.ts